/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProductCreateResp
 */
export interface AdminProductCreateResp {
    /**
     * 
     * @type {string}
     * @memberof AdminProductCreateResp
     */
    id: string;
}

export function AdminProductCreateRespFromJSON(json: any): AdminProductCreateResp {
    return AdminProductCreateRespFromJSONTyped(json, false);
}

export function AdminProductCreateRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductCreateResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function AdminProductCreateRespToJSON(value?: AdminProductCreateResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

